import { FormattedMessage } from "react-intl";

import styles from "@components/MedicationAvatar.module.css";
import Icon from "@components/text/Icon";
import { MedicationKindEnum } from "@typing/Generated";

type Props = {
  medicationKind: MedicationKindEnum;
};

const MedicationAvatar = ({ medicationKind }: Props) => (
  <div className={styles.avatar}>
    {medicationKind === MedicationKindEnum.prescription ? (
      <Icon icon="prescription" />
    ) : medicationKind === MedicationKindEnum.over_the_counter ? (
      <FormattedMessage id="pages.client.medications.list.oTC" />
    ) : (
      <FormattedMessage id="pages.client.medications.list.vAndS" />
    )}
  </div>
);

export default MedicationAvatar;
